import styled from 'styled-components'

import { MEDIA_QUERY } from '../../../../../styles'
import { ButtonLink } from '../../../../forms/button/button-link'


export const ResultCtaStyled = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px 0;
  margin: auto;
  @media ${MEDIA_QUERY.MOBILE} {
    padding: 30px 20px;
    width: 100%;
  }
`

export const CtaLinkButton = styled(ButtonLink)`
  width: 100%;
`

export const ButtonWrapper = styled.div`
  button,
  > a {
    min-width: 240px;
    height: 50px;
  }
`
